import React from 'react';
import { Route, IndexRoute } from 'react-router';

import App from './components/App';
import Navigation from './components/Navigation'
import NotFoundPage from './components/NotFoundPage.js';

export default (
  <Route path="/" component={App}>
    <IndexRoute component={Navigation}/>
    <Route path="nav/:child" component={Navigation}/>
  </Route>
);



/** WEBPACK FOOTER **
 ** ./src/routes.js
 **/